import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import StatisticsSection from './components/StatisticsSection';
import WhyTrainingStrategic from './components/WhyTrainingStrategic';
import WhatIsTraining from './components/WhatIsTraining';
import TasksSolved from './components/TasksSolved';
import CompanyMistakes from './components/CompanyMistakes';
import ModernSystem from './components/ModernSystem';
import TrainingFormats from './components/TrainingFormats';
import WhoNeedsTraining from './components/WhoNeedsTraining';
import HowToMeasure from './components/HowToMeasure';
import CaseStudy from './components/CaseStudy';
import WhyTrainingFails from './components/WhyTrainingFails';
import WhyBusinessTraining from './components/WhyBusinessTraining';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Почему важно', target: 'why-strategic' },
  { label: 'Задачи', target: 'tasks' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function StaffTrainingPage() {


  return (
    <>
      
      <SeoTitle title="Обучение персонала | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <StatisticsSection />
        <WhyTrainingStrategic />
        <div id="tasks">
          <TasksSolved />
        </div>
        <WhatIsTraining />
        <CompanyMistakes />
        <ModernSystem />
        <div id="formats">
          <TrainingFormats />
        </div>
        <WhoNeedsTraining />
        <HowToMeasure />
        <CaseStudy />
        <WhyTrainingFails />
        <WhyBusinessTraining />
        <LeadMagnetBlock variant="full" />
        <CTASection />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}